import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import styles from './RowEditActions.module.scss';

const RowEditActions = ({ confirmLabel, cancelLabel, onConfirm, onCancel }) => (
  <span className={styles.actions}>
    <Tooltip title={confirmLabel}>
      <IconButton
        size="small"
        className={`${styles.button} ${styles.confirm}`}
        aria-label={confirmLabel}
        onClick={onConfirm}
      >
        <CheckIcon fontSize="small" aria-hidden="true" />
      </IconButton>
    </Tooltip>
    <Tooltip title={cancelLabel}>
      <IconButton
        size="small"
        className={styles.button}
        aria-label={cancelLabel}
        onClick={onCancel}
      >
        <CloseIcon fontSize="small" aria-hidden="true" />
      </IconButton>
    </Tooltip>
  </span>
);

RowEditActions.propTypes = {
  confirmLabel: PropTypes.string.isRequired,
  cancelLabel: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default RowEditActions;
